import React, { useState } from "react";
import Footer from "./Footer";
import "../styles/VenuePage.css";
import { venueDescriptions } from "../utils/venueData";

import icon_wrapper from "../images/venue/icons/icon_wrapper.png";
import embassy from "../images/venue/icons/new/embassy.png";
import mine from "../images/venue/icons/new/mine.png";
import maze from "../images/venue/icons/new/maze.png";
import lockhart88 from "../images/venue/icons/new/lockhart88.png";
import port from "../images/venue/icons/new/port.png";
import zinc from "../images/venue/icons/zinc.png";
import taboo from "../images/venue/icons/new/taboo.png";
import graffiti from "../images/venue/icons/new/graffiti.png";
import gate from "../images/venue/icons/new/gate.png";
import thestation from "../images/venue/icons/new/thestation.png";
import centrico from "../images/venue/icons/new/centrico.png";

import fz1 from "../images/home/embassy.jpg";
import fz2 from "../images/home/fz2.png";
import fz3 from "../images/home/fz3.png";
import fz4 from "../images/home/fz4.png";
import fz5 from "../images/home/fz5.png";
import fz6 from "../images/home/fz6.png";
import fz7 from "../images/home/fz7.png";
import fz8 from "../images/home/fz8.png";
import fz9 from "../images/home/fz9.png";
import fz10 from "../images/home/fz10.png";

const venueImages = [fz1, fz2, fz3, fz4, fz5, fz6, fz8, fz9, fz10];

const VenuePage = () => {
  const [activeVenue, setActiveVenue] = useState(null);

  const venues = [
    { name: "EMBASSY", url: "embassy", icon: embassy, description: venueDescriptions.embassy },
    { name: "MINE", url: "mine", icon: mine, description: venueDescriptions.mine },
    { name: "MAZE BAR", url: "maze", icon: maze, description: venueDescriptions.maze },
    { name: "LOCKHART 88", url: "lockhart88", icon: lockhart88, description: venueDescriptions.lockhart88 },
    { name: "PORT", url: "port", icon: port, description: venueDescriptions.port },
    { name: "TABOO", url: "taboo", icon: taboo, description: venueDescriptions.taboo },
    // { name: "GRAFFITI", url: "graffiti", icon: graffiti, description: venueDescriptions.graffiti, hidden: true },
    { name: "GATE", url: "gate", icon: gate, description: venueDescriptions.gate },
    { name: "THE STATION", url: "thestation", icon: thestation, description: venueDescriptions.thestation },
    { name: "CENTRICO", url: "centrico", icon: centrico, description: venueDescriptions.centrico }
  ];

  const handleMouseEnter = (index) => {
    setActiveVenue(index);
  };

  const handleMouseLeave = () => {
    setActiveVenue(null);
  };

  return (
    <>
      <div className="venue-page-container inPage">
        <div className="venue-header">
          <h1>VENUES</h1>
        </div>

        {/* 桌面版展示 */}
        <div className="venue-grid d-none d-lg-grid">
          {venues.filter(venue => !venue.hidden).map((venue, index) => (
            <div
              key={index}
              className={`venue-card ${activeVenue === index ? 'active' : ''}`}
              onMouseEnter={() => handleMouseEnter(index)}
              onMouseLeave={handleMouseLeave}
            >
              <div className="venue-image" style={{ backgroundImage: `url(${venueImages[index]})`, backgroundPosition: 'top' }}>
                <div className="venue-overlay">
                  <div className="venue-icon-wrapper">
                    {/* <img src={icon_wrapper} alt={venue.name} className="venue-wrapper" /> */}
                    <img src={venue.icon} alt={venue.name} className="venue-icon" />
                  </div>
                  {/* <h3>{venue.name}</h3> */}
                  <p>{venue.description}</p>
                  <a href={`https://${venue.url}.zincgroup.com.hk`} target="_blank" rel="noreferrer" className="venue-button">
                    Visit
                  </a>
                </div>
              </div>
              <div className="venue-name-bar">
                <span>{venue.name}</span>
              </div>
            </div>
          ))}
        </div>

        {/* 平板版展示 */}
        <div className="venue-list d-none d-md-block d-lg-none">
          <div className="row">
            {venues.filter(venue => !venue.hidden).map((venue, index) => (
              <div key={index} className="col-md-4 mb-4">
                <div className="venue-item">
                  <div className="venue-item-image" style={{ backgroundImage: `url(${venueImages[index]})`, backgroundPosition: 'top' }}>
                    <div className="venue-item-overlay">
                      <h4>{venue.name}</h4>
                      <a href={`https://${venue.url}.zincgroup.com.hk`} target="_blank" rel="noreferrer" className="venue-item-link">
                        Visit
                      </a>
                    </div>
                  </div>
                  <div className="venue-item-info">
                    <div className="venue-icon-wrapper">
                      {/* <img src={icon_wrapper} alt={venue.name} className="venue-wrapper" /> */}
                      <img src={venue.icon} alt={venue.name} className="venue-icon" />
                    </div>
                    <h5 className="ml-2">{venue.name}</h5>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 移动版展示 */}
        <div className="venue-mobile d-md-none">
          <div className="row">
            {venues.filter(venue => !venue.hidden).map((venue, index) => (
              <div key={index} className="col-6 mb-3">
                <div className="venue-mobile-item">
                  <div className="venue-icon-wrapper">
                    {/* <img src={icon_wrapper} alt={venue.name} className="venue-wrapper" /> */}
                    <img src={venue.icon} alt={venue.name} className="venue-icon" />
                  </div>
                  <h5>{venue.name}</h5>
                  <a href={`https://${venue.url}.zincgroup.com.hk`} target="_blank" rel="noreferrer" className="venue-mobile-link">
                    Visit
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="footer d-lg-none">
        <Footer />
      </div>
    </>
  );
};

export default VenuePage;
